import { BrowserRouter, Routes, Route } from "react-router-dom";


import { AlertProvider } from "./context/AlertContext";
import Charity from "./pages/Charity";
import MNF from "./pages/MNF";
import ChickenLicious from "./pages/ChickenLicious";
import Home from "./pages/Home";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <BrowserRouter>
    <AlertProvider>
    <ScrollToTop/>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/tournament" element={<Charity/>}/> 
        <Route path="/mnf" element={<MNF/>}/>
        <Route path="/chickenLicious" element={<ChickenLicious/>}/>
      </Routes>
      
    </AlertProvider>
    </BrowserRouter>
  );
}

export default App;
